import React from "react"

export default (props) => (
  // <svg
  //   xmlns="http://www.w3.org/2000/svg"
  //   viewBox="0 0 21.41 21.41"
  //   className="fill-current"
  // >
  //   <path d="M12.12 10.71L21.41 20 20 21.41l-9.29-9.29-9.3 9.29L0 20l9.29-9.29L0 1.41 1.41 0l9.3 9.29L20 0l1.41 1.41z" />
  // </svg>
  <svg stroke="currentColor" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M6 18L18 6M6 6l12 12"
    ></path>
  </svg>
)
